export type TermsCheckoutPart = {
  termsAgreement: boolean;
  newsletterConsent: boolean;
  bookclubTermsAgreement?: boolean;
};

export const CHECKOUT_TERMS_TYPES = {
  purchase: "kjopsvilkar",
  newsletter: "nyhetsbrevvilkar",
  subscription: "abonnementsvilkar",
  bookclub: "bokklubvilkar",
} as const;

export type CheckoutTermsType = keyof typeof CHECKOUT_TERMS_TYPES;
